import { useProfile, dayNumberFromStartDate } from '../lib/hooks'
import DayDetail from './DayDetail'
import StartDatePrompt from '../components/StartDatePrompt'
import LoadingScreen from '../components/LoadingScreen'

export default function Today() {
  const { profile, loading } = useProfile()

  if (loading) return <LoadingScreen />
  if (!profile?.startDate) return <StartDatePrompt />

  const dayNumber = dayNumberFromStartDate(profile.startDate)
  return <DayDetail dayNumber={dayNumber} isToday />
}
